<style src="./elements.css" scoped></style>

<template>
  <div class="project-list-container">
    <h1 class="page-title">Bug & Feature Reports</h1>
    <div class="actions">
      <!-- Open Ticket button: using router-link so that users can navigate to /new-ticket -->
      <router-link to="/new-ticket" class="action-button">
        Open Ticket
      </router-link>
    </div>
    <div v-if="loading">Loading tickets...</div>
    <div v-if="error" class="error-message">{{ error }}</div>
    <table class="project-table" v-if="tickets.length">
      <thead>
        <tr>
          <th>TYPE</th>
          <th>SUMMARY</th>
          <th>STATUS</th>
          <th>STATE</th>
          <th>CREATED AT</th>
          <th>ADDED BY</th>
        </tr>
      </thead>
      <tbody>
        <tr 
          v-for="ticket in tickets" 
          :key="ticket.id" 
          @click="goToTicketDetails(ticket.id)"
          class="clickable-row"
        >
          <td>{{ ticket.type }}</td>
          <td class="project-link">{{ ticket.summary }}</td>
          <td>{{ ticket.status }}</td>
          <td>{{ getStatusEmoji(ticket.status) }}</td>
          <td>{{ ticket.timestamp ? ticket.timestamp.toDate().toLocaleString() : "" }}</td>
          <td>{{ ticket.addedBy }}</td>
        </tr>
      </tbody>
    </table>
    <div v-else>
      <p>No tickets found.</p>
    </div>
  </div>
</template>

<script>
import BugReportListLogic from "./BugReportListLogic.js";

export default {
  name: "BugReportList",
  mixins: [BugReportListLogic],
  methods: {
    // Navigates to the ticket details page based on the ticketID.
    goToTicketDetails(ticketID) {
      this.$router.push(`/tickets/${ticketID}/details`);
    },
    // Returns an emoji based on the ticket's status
    getStatusEmoji(status) {
      switch(status) {
        case "Open":
          return "🔵";
        case "Live":
          return "🟢";
        case "Stuck":
          return "🔴";
        case "Developing":
          return "🟡";
        default:
          return "";
      }
    }
  }
};
</script>

<style src="./listingTables.css" scoped></style>
